import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Roles } from '../models/roles.model';

const URL = environment.PROCEDURE_SECURITY_URI;

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private http: HttpClient)
  { }

  traerRoles(): Observable<Roles[]>{
    return this.http.get<Roles[]>(`${ URL }/GetRoles`);
  }

  traerRol(nombre: string): Observable<Roles[]>{
    return this.http.get<Roles[]>(`${ URL }/GetRoles?type=rol&search=${ nombre }`);
  }

  traerRolById(codigo: string): Observable<Roles[]>{
    return this.http.get<Roles[]>(`${ URL }/GetRoles?type=codigo&search=${ codigo }`);
  }


  actualizarRol(rol: any): Observable<any>{
    return this.http.put<any>(`${ URL }/UpdateRole`, rol);
  }

  crearRol(rol: any): Observable<any>{
    return this.http.post<any>(`${ URL }/AddRole`, rol);
  }

  revisarRol(nombre: string): Observable<any>{
    return this.http.get<any>(`${ URL }/GetRoles?type=rol&search=${ nombre }`);
  }
}
